// @flow
import { get } from 'lodash';

type PaymentError = {
  code?: string,
  message: string,
};

const ERROR_MESSAGES = {
  US_BANK_ACCOUNT_FAILED_TOKENIZATION:
    'There is a problem with your bank details. Please check each field and try again, or contact support',
  UNKNOWN: 'Something went wrong. Please try again later, or contact support.',
};

const mapErrorMessage = (error: PaymentError) => {
  // Special case for un-verifiable bank accounts
  // Need a better solution long term
  if (get(error, 'message', '').includes('Try Another Verification Method')) {
    return "Sorry, we weren't able to authorize your bank account. Please try another bank account or use a Credit Card or PayPal.";
  }

  const errorMessage = error.code
    ? ERROR_MESSAGES[error.code]
    : error.message
    ? error.message
    : ERROR_MESSAGES.UNKNOWN;

  if (errorMessage.includes('GraphQL error: ')) {
    return errorMessage.replace('GraphQL error: ', '');
  }

  return errorMessage;
};

export default mapErrorMessage;
